import { pathJoin } from 'src/reducers/routing/utils'

export const createDashboardsDetailViewRoutesMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  edit: pathJoin(prefix)('edit').chain,
})
